export default __webpack_public_path__ + "static/media/InternalServerError.fde998b0.svg";